import AxiosClient from "../../../services/axios.services";

class NotificationHistoryServices {
  getNotificationHistory = (params) =>
    AxiosClient.get(
      "/api/app/notificacion_correo_historial/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );


  saveNotificationHistory = (data) =>
    AxiosClient.post(
      "/api/app/notificacion_tipo_colaborador/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editNotificationHistory = (id, data) =>
    AxiosClient.put(
      `/api/app/notificacion_tipo_colaborador/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );


}

export default new NotificationHistoryServices();
